import { render, staticRenderFns } from "./user-event-modal.vue?vue&type=template&id=fff4b4ea&"
import script from "./user-event-modal.vue?vue&type=script&lang=js&"
export * from "./user-event-modal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports